import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToasterService } from 'angular-toaster';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

/**
 * [SCBMP-T841] The BE answers an expired/missing token with HTTP 200 and outcome 0005/0007.
 * Without this every pending call showed its own error toast on top of the login page:
 * here we redirect once, drop the toasts and swallow the response so no component sees it.
 */
@Injectable()
export class SessionExpiredInterceptor implements HttpInterceptor {

  private redirecting = false;

  constructor(private router: Router, private toasterService: ToasterService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      mergeMap((event) => {
        if (!(event instanceof HttpResponse)) {
          return of(event);
        }
        const code = event.body?.outcome?.code;
        if (code !== '0005' && code !== '0007') {
          this.redirecting = false;
          return of(event);
        }
        if (!this.redirecting) {
          this.redirecting = true;
          localStorage.clear();
          this.toasterService.clear();
          this.router.navigate(['/login/1']);
        }
        return EMPTY;
      })
    );
  }

}
